import React, { useRef } from 'react'
import PropTypes from 'prop-types'

import styles from './style.scss'

const RadioButton = (props) => {
  const { name, label, value, isChecked, id, disabled, onCheck } = props
  const radiobutton = useRef(null)

  const handlerChecked = (e) => {
    if (onCheck) onCheck(radiobutton.current.value)
  }

  return (
    <div
      className={[
        styles['RadioButton'],
        styles[`${disabled ? ' RadioButton--disabled' : ''}`]
      ].join(' ')}
    >
      <label htmlFor={id}>
        <input
          type='radio'
          name={name}
          id={id}
          ref={radiobutton}
          value={value}
          checked={isChecked}
          onChange={handlerChecked}
          disabled={disabled}
        />
        {label && (
          <div>
            <p>{label}</p>
          </div>
        )}
      </label>
    </div>
  )
}

RadioButton.defaultProps = {
  label: '',
  value: '',
  isChecked: false,
  id: '',
  disabled: false,
  onCheck: () => {}
}

RadioButton.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.string,
  isChecked: PropTypes.bool,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  onCheck: PropTypes.func
}

export default RadioButton
